// AI Generated Component
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { PagePageLinksRepoService } from '@client/app/services/api/pages/page-links-repo.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { QABrokenLinkService } from '@client/app/blocks/service/qa/broken-link.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'page-details-section-qa-broken',
    standalone: false,
    template: `
        <div class="d-flex align-items-center mb-2">
            <span class="fa-2x fa-fw mr-2 text-link mt-1" aria-hidden="true" [class]="icon"></span>
            <div>
                <h2 class="font-weight-300 mb-0">
                    {{ headline }}
                </h2>
                @let totalLinks = links.total | monNumber;
                <span class="text-grey"
                      translate
                      [translate-args]="{$count: totalLinks}"
                      [translate-n]="totalLinks"
                      translate-plural="[[$count]] issues found">
                    1 issue found
                </span>
            </div>
        </div>
        <div class="mr-3">
            <mon-tabs [showSearch]="true"
                      [options]="tabs"
                      [(status)]="activeTab"
                      (onStatus)="onStatus($event)"
                      (onSearch)="onSearch($event)"
                      [search]="search"
                      [minSearchLength]="1"
                      [showFiltersBtn]="true"
                      [(isFiltersOpen)]="isFiltersOpen">
                <csv-export-button [exports]="exports"></csv-export-button>
            </mon-tabs>
            <div class="card panel-monsido-card">
                <div class="card-body">
                    <div *ngIf="isFiltersOpen" class="merge-t-8 merge-r-16 merge-l-16 mb-3">
                        <table-filters
                                [(open)]="isFiltersOpen"
                                [(ngModel)]="filters"
                                name="filters"
                                [filters]="availableFilters"
                                (onChanges)="updateFilters($event);getPage()"
                        >
                        </table-filters>
                    </div>
                    <page-details-brokenlinks-table
                            [page]="pageObj"
                            [selected]="selected"
                            [items]="links"
                            (onPageChange)="onPageChange($event)"
                            (onPerPageChange)="onPageSizeChange($event)"
                            (getPage)="getPage()"
                            (refreshPage)="refreshPage.emit()"
                            [type]="activeTab"
                            [progress]="promise"
                            [moduleName]="headline">
                    </page-details-brokenlinks-table>
                </div>
            </div>
        </div>
    `,
})
export class PageDetailsSectionQaBrokenComponent extends BaseContainerComponentController implements OnInit {
    @Input() headline: string = '';
    @Input() icon: string = '';
    @Input() pageObj: any = {};
    @Input() type: string = '';
    @Output() refreshPage = new EventEmitter<any>();

    selected: any[] = [];
    links: any = [];
    tabs: any[] = [];
    override isFiltersOpen: boolean = false;
    override filters: any = { type: [], 'response code': [] };
    override availableFilters: any = {};
    override activeTab: string = 'dead';
    override search: string = '';
    exports: any[] = [];
    promise: any;

    constructor (
        private pagePageLinksRepoService: PagePageLinksRepoService,
        private translateService: TranslateService,
        private qaBrokenLinkService: QABrokenLinkService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.selected = [];
        this.pageObj = this.pageObj || {};
        this.search = '';
        this.type = this.type || 'not_image';
        this.links = [];
        this.activeTab = 'dead';
        this.tabs = [
            { name: this.translateService.getString('All'), value: 'dead' },
            { name: this.translateService.getString('Ignored'), value: 'ignored' },
            { name: this.translateService.getString('Marked as fixed'), value: 'fixed' },
        ];
        this.isFiltersOpen = false;
        this.filters = { type: [], 'response code': [] };
        this.availableFilters = {
            type: [{ id: 'html', name: 'Pages' }, { id: 'document', name: 'Documents' }],
            'response code': this.qaBrokenLinkService.getResponseCodes(),
        };
        this.exports = [
            {
                name:
                    this.type === 'not_image'
                        ? this.translateService.getString('Broken Links')
                        : this.translateService.getString('Broken Images'),
                data: {
                    category: this.type === 'not_image' ? 'dead_links' : 'dead_images',
                    category_ref: this.pageObj.id,
                },
            },
        ];

        this.getPage();
    }

    override getPage = (): void => {
        this.selected = [];
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            status: this.activeTab,
            type: this.type,
            search: this.search ?? '',
        };

        if (this.filters.type.length) {
            params.page_type = this.filters.type[0].id;
        }
        if (this.filters['response code'].length) {
            params.status_code = this.filters['response code'][0].id;
        }

        params.page_fixed = false;

        this.promise = this.pagePageLinksRepoService.getAll(this.pageObj.id, params).then((data: any) => {
            this.links = data;
        }, () => {});
    };

    override updateFilters (changes: any): void {
        if (changes.type.length === 1) {
            this.filters.type = changes.type;
        } else if (changes.type.length > 1) {
            this.filters.type.splice(0, 1);
        } else {
            this.filters.type = [];
        }
        if (changes['response code'].length === 1) {
            this.filters['response code'] = changes['response code'];
        } else if (changes['response code'].length > 1) {
            this.filters['response code'].splice(0, 1);
        } else {
            this.filters['response code'] = [];
        }
        this.getPage();
    }
}
